import { Divider, Switch, Text, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/app/hooks';
import { RootState } from '../../../redux/app/store';
import { FeatureKeys, Setting } from '../../../redux/features/app/AppState';
import { toggleFeatureFlag } from '../../../redux/features/app/appSlice';

const useClasses = makeStyles({
    feature: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalNone,
    },
    featureDescription: {
        paddingLeft: '5%',
        paddingBottom: tokens.spacingVerticalS,
    },
    wrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    wrapperColumn: {
        flexDirection: 'column',
    },
    featureDescriptionDisabled: {
        color: tokens.colorNeutralForegroundDisabled,
    },
    featureDescriptionEnabled: {
        color: tokens.colorNeutralForeground2,
    },
});

interface ISettingsSectionProps {
    setting: Setting;
    contentOnly?: boolean;
}

export const SettingSection: React.FC<ISettingsSectionProps> = ({ setting, contentOnly }) => {
    const classes = useClasses();
    const { features } = useAppSelector((state: RootState) => state.app);
    const dispatch = useAppDispatch();

    const onFeatureChange = useCallback(
        (featureKey: FeatureKeys) => {
            dispatch(toggleFeatureFlag(featureKey));
        },
        [dispatch],
    );

    return (
        <>
            {!contentOnly && <h3>{setting.title}</h3>}
            {setting.description && <p>{setting.description}</p>}
            <div className={mergeClasses(classes.wrapper, setting.stackVertically && classes.wrapperColumn)}>
                {setting.features.map((key) => {
                    const feature = features[key];
                    return (
                        <div key={key} className={classes.feature}>
                            <Switch
                                label={feature.label}
                                checked={feature.enabled}
                                disabled={!!feature.inactive}
                                onChange={() => {
                                    onFeatureChange(key);
                                }}
                                data-testid={feature.label}
                            />
                            <Text
                                className={mergeClasses(
                                    classes.featureDescription,
                                    feature.inactive
                                        ? classes.featureDescriptionDisabled
                                        : classes.featureDescriptionEnabled,
                                )}
                            >
                                {feature.description}
                            </Text>
                        </div>
                    );
                })}
            </div>
            {!contentOnly && <Divider />}
        </>
    );
};
